function Map() {
	return (
		<section id="google-map">
			{/* How to change your own map point
            1. Go to Google Maps
            2. Click on your location point
            3. Click "Share" and choose "Embed map" tab
            4. Copy only URL and paste it within the src="" field below
	*/}
			<iframe title='Sitepartenaire' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.2797520734744!2d2.230787916061956!3d48.87194330770575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e664d88a95df4d%3A0xd791540f85723c90!2sOlaqin!5e0!3m2!1sfr!2sfr!4v1619697136405!5m2!1sfr!2sfr" width="100%" height={350} frameBorder={0} style={{border: 0}} allowFullScreen />
		</section>
	);
}

export default Map;